'use strict'

import Vue from 'vue'
import App from './App.vue'

import VueFormat from 'vue-format'
import VueMoment from 'vue-moment'

import {SUBSITE} from './store/defaults'
import router from './router/index'
import store from './store/index'

import vuetify from './plugins/vuetify';
// импортируем экземпляр плагина
import ampli_var_stat from './plugins/ampli_var_stat'


Vue.config.productionTip = false

// Vue.use(Vuex) плагин уже подключен в ./store/index
Vue.use(VueFormat)
Vue.use(VueMoment)

// для объекта ampli_var_stat (класса AmpliVarStat)
// будет вызыван метод install() экземпляра (в нем будет this)
// передаем router в регистрацию плагина, чтобы иметь доступ к истории (?)
// и store тоже передаем, чтобы добавить в него модули
Vue.use(ampli_var_stat, SUBSITE, router, store)

// это тоже что-то типа плагина получилось
const bus = new Vue()
Vue.prototype.$bus = bus

// Метод .beforeEach принимает функцию обработчик как аргумент, а не присваиваем функцию обработчик
router.beforeEach(function (to, from, next) {
	console.debug("router.beforeEach() ")
	if (typeof to.matched[0]?.components.default === 'function') {
		bus.$emit('asyncComponentLoading', to)
	}
	next()
})

router.beforeResolve(function (to, from, next) {
	console.debug("router.beforeResolve() ")
	bus.$emit('asyncComponentLoaded')
	next()
})

// регистрируем компоненты глобально, чтобы они были доступны в плагинах
import DefaultView from './views/DefaultView'
import DefaultDialog from './views/DefaultDialog'

Vue.component('default-view', DefaultView)
Vue.component('default-dialog', DefaultDialog)

new Vue({
	router,
	store,
	vuetify,

	ampli_var_stat,

	render: h => h(App)
}).$mount('#app')
